import { cloneElement, MouseEvent, ReactElement, useState } from 'react';

import styled from '@emotion/styled';
import MuiMenu, { menuClasses } from '@mui/material/Menu';
import MuiMenuItem, { menuItemClasses } from '@mui/material/MenuItem';
import { LocaleLanguage } from '@repo/i18n';

import { useLocale } from './NextIntlProvider';

const Menu = styled(MuiMenu)`
  .${menuClasses.paper} {
    background-color: ${({ theme }) => theme.color.surfaceContainer};
    border-radius: ${({ theme }) => theme.shape.corner['1000']};
    box-shadow: ${({ theme }) => theme.elevation.level1};
  }
`;
const MenuItem = styled(MuiMenuItem)`
  &.${menuItemClasses.root} {
    color: ${({ theme }) => theme.color.onSurface};
    font: ${({ theme }) => theme.typography.body.regular};
    font-size: ${({ theme }) => theme.typescale.size['0875']};

    padding-block: ${({ theme }) => theme.spacing('0750')};
    padding-inline: ${({ theme }) => theme.spacing('1000')};
  }
`;

export interface ILanguageMenuProps {
  Trigger: ReactElement;
}
export function LanguageMenu({ Trigger }: ILanguageMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpen = (event: MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isOpen = Boolean(anchorEl);
  const { locale, availableLocales, setLocale } = useLocale();
  const handleChange = (locale: LocaleLanguage) => {
    setLocale(locale);
    handleClose();
  };

  return (
    <>
      {cloneElement(Trigger, { onClick: handleOpen })}
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleClose}
      >
        {availableLocales.map(({ value, label }) => (
          <MenuItem
            key={value}
            selected={value === locale}
            onClick={() => handleChange(value)}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
